import { useEffect, useState } from 'react';
import { Column, ImagesViewer, Row } from '../../../../../../components/Basic/Blocks';
import { Icon, Link } from '../../../../../../components/Basic/Elements';
import { InputLabel } from '../../../../../../components/Basic/Inputs';
import { H2, Text } from '../../../../../../components/Basic/WrapsStyle';
import { GO_TO_WB } from '../../../../../../components/Markets/Blocks/Table/Line';
import { MAP_MARKETS } from '../../../../../../constans/markets';
import styles from './styles.module.scss';

const map = MAP_MARKETS;
const OneMarket = ({ market = '', sku = '', info = { profit: {}, image: '' }, ...props }) => {
  const [product, setProduct] = useState({
    id: '',
    name: '',
    images: [],
    stock: 0,
    price: 0,
    profit: {
      all: 0,
    },
    num: 1,
  });

  useEffect(() => {
    setProduct(info);
  }, [info]);

  return (
    <>
      <Row style={{ marginBottom: '15px' }}>
        <Icon src={map[market] ? map[market].icon : null} width={40} />
        <H2 fontSize={16} classNames={styles.title_market}>
          {map[market] ? map[market].title : ''}
        </H2>
      </Row>

      <Row style={{ alignItems: 'flex-start' }}>
        <Column className={styles.market_product} style={{ borderLeftColor: map[market] ? map[market].color : null }}>
          <Row className={styles.row_input}>
            <InputLabel styles={styles.label}>Артикул</InputLabel>
            <Text fontWeight={600}> {product.offer_id} </Text>{' '}
            {(market === 'wb' || market === 'wb2' || market === 'wb3' || market === 'wb4' || market === 'wb5') && (
              <Link
                blue={true}
                href={GO_TO_WB(product.marketId)}
                style={{ marginLeft: '15px', fontSize: '14px' }}
                target={'_blank'}
              >
                {product.marketId}
              </Link>
            )}
          </Row>
          <Row className={styles.row_input}>
            <InputLabel styles={styles.label}>Наименование</InputLabel>
            <Text> {product.name}</Text>
          </Row>
        </Column>
        {(product.images || []).length > 0 && (
          <div className={styles.wrapper}>
            <ImagesViewer images={product.images} className={styles.preview} small={false} />
          </div>
        )}
      </Row>
    </>
  );
};

export default OneMarket;
